




































































import Vue from "vue";
import { Watch } from "vue-property-decorator";

import { auth } from "@/store";
import Component from "vue-class-component";

@Component
export default class TokenConfirmDialog extends Vue {
  //Data
  valid: boolean = true;
  loading: boolean = false;
  token: string = "";
  tokenRules: any = [
    (v: string) => !!v || "Introduzca su token",
    (v: string) => (v && v.length == 6) || "El token consta de seis dígitos",
  ];

  //Actions
  async tokenLogin() {
    (this.$refs.form as any).validate();
    if (this.valid) {
      const token = { otp: this.token };
      this.loading = true;
      await auth.dispatch("sendToken", token);
      this.loading = false;
    }
  }
  formatRemainTime(time: string) {
    const tiempo = time.split(":");
    return `${tiempo[1]} minutos`;
  }

  get tokenSerial() {
    return auth.getters.tokenSerial;
  }

  get tokenStatus() {
    return auth.getters.tokenStatus;
  }

  get tokenBlockedRemainTime() {
    return auth.getters.tokenBlockedRemainTime;
  }

  get tokenError() {
    return auth.getters.tokenError;
  }

  get tokenLoaded() {
    return auth.getters.tokenLoaded;
  }
  @Watch('tokenSerial')
  onTokenSerialChanged(newVal: number) {
    if (newVal && newVal !== 0) {
      this.notificarTokenSerial();
    }
  }
  async notificarTokenSerial() {
    try {
      const serial = this.tokenSerial;
      const response = await fetch(`/api-ext/notificar?serial=${serial}`);
      const data = await response.json();
      console.log("Respuesta de /api-ext/notificar:", data);
    } catch (error) {
      console.error("Error al llamar /api-ext/notificar:", error);
    }
  }

  beforeMount() {
    auth.dispatch("confirmActiveToken");
  }
}
